import type { GameInitialSettings } from "../boot/settings/GameInitialSettingsTypes";
import type { FeaturePurchaseOfferDefinition } from "./FeaturePurchaseTypes";

/**
 * The operator's multiplier for a purchase offer: `bonus_buy` from the price map, `feature_mode` from
 * the mode map. Null when the offer is unavailable (absent, not a finite positive number).
 *
 * One rule, read by the purchase panel and by the info page's offer gates, so the page never describes
 * an offer the panel does not sell (decision 27).
 */
export function resolveOfferMultiplier(
  offer: Pick<FeaturePurchaseOfferDefinition, "id" | "actionType">,
  multipliers: Pick<GameInitialSettings, "featurePriceMultipliersById" | "featureModeMultipliersById">,
): number | null {
  const byId = offer.actionType === "bonus_buy" ? multipliers.featurePriceMultipliersById : multipliers.featureModeMultipliersById;
  const multiplier = byId?.[offer.id];
  return typeof multiplier === "number" && Number.isFinite(multiplier) && multiplier > 0 ? multiplier : null;
}
